import Vue from 'vue'
import { mapObj, transformUrl } from '@/utils/util'

Vue.mixin({
  data() {
    return {
      isLoading: false,
      hasInited: false,
    }
  },
  async created() {
    await this.$reInitData()
  },
  computed: {
    $id() {
      const { id } = this.$route.params
      return id
    }
  },
  watch: {
    $route: '$reInitData'
  },
  methods: {
    async $reInitData() {
      if (this.initData) {
        this.isLoading = true
        await this.initData()
        this.hasInited = true
        this.isLoading = false
      }
    },
    get: _.get,
    pick: _.pick,
    // 字段名自动根据 data 里的字段映射
    $mapObj: mapObj,
    globalIndex(index) {
      const { pageNo, pageSize } = this.queryParam
      return (pageNo - 1) * pageSize + index + 1
    },
    cdnImg: transformUrl
  }
})
